
export { CollectionName } from "/codebuild/output/src1086538210/src/packages/search-document-builders/src/registry/collection-registry.ts"
export { collectionAlias } from "./registry/schema-registry"